import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import SeoPageServices from "services/SeoPageServices";
import { notifyError, notifySuccess } from "utils/toast";

const useSeoPageSubmit = (id) => {
  
  const { isDrawerOpen, closeDrawer, setIsUpdate } =
    useContext(SidebarContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedfromCity, setSelectedfromCity] = useState(null);
  const [selectedtoCity, setSelectedtoCity] = useState(null);
  const [selectedfromCityName, setSelectedfromCityName] = useState(null);
  const [selectedtoCityName, setSelectedtoCityName] = useState(null);
  const [selectedTripType, setSelectedTripType] = useState("");
  const [selectedVehicleCategory, setSelectedVehicleCategory] = useState(null);
  const [dataInput, setDataInput] = useState([{"vehicle_type_0":"","4h_40km_0":"","6h_60km_0":"","8h_80km_0":"","10h_100km_0":"","extra_km_0":"","extra_hr_0":"","prime_0":""}]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);
  const handleVehicleCategoryChange = (e, index) => {
    const { name,value } = e.target;
    //selected value
    const onChangeVals = [...dataInput];
    onChangeVals[index][name] = value;
    setDataInput(onChangeVals);
    // selected options
    const updatedSelectedOptions = [...selectedOptions];
    updatedSelectedOptions[index] = value;
    setSelectedOptions(updatedSelectedOptions);

  };

  const {
    trigger,
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm();
  
  const handlefromCityChange = (city_id,city_name) => {
    setSelectedfromCity(city_id);
    setSelectedfromCityName(city_name);
  };

  const handletoCityChange = (city_id,city_name) => {
    setSelectedtoCity(city_id);
    setSelectedtoCityName(city_name);
  };


  const handleChangeInput = (e, i) => {
    if(e&&e.target){
    const { name, value } = e.target;
    const onChangeVal = [...dataInput];
    onChangeVal[i][name] = value;
    setDataInput(onChangeVal);
    }
  };
  const onSubmit = async (data) => {
    setLoading(true);
    data.content = content;
    data.from_city = selectedfromCityName;  // Assign correct city name
    data.from_city_id = selectedfromCity;  // Assign correct city ID
    data.to_city = selectedtoCityName;  // Assign correct city name
    data.to_city_id = selectedtoCity;  // Assign correct city ID
    data.type_of_trip = selectedTripType;
    data.is_manual = 1;

    
    const sanitizeContent = (content) => {
      const sanitizedContent = content.replace(/<p>\s*<br>\s*<\/p>/g, "").trim();
      return sanitizedContent;
    };

    // Function to validate content
    const handleContentValidation = () => {
      const sanitizedContent = sanitizeContent(content);  // Sanitize the content
      if (!sanitizedContent.trim()) {
        notifyError("Content is required.");  // Notify error if content is empty after sanitization
        setLoading(false);
        return false;  // Return false to stop form submission
      }
      return true;  // Proceed with form submission if content is valid
    };

  if (!handleContentValidation()) {
     setLoading(false);
      return;  // Prevent form submission if content is invalid
  }

    try {
      
      setIsSubmitting(true);
  
      if (id) {
        const res = await SeoPageServices.updateSeoPage(id,data);
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      } else {
        const res = await SeoPageServices.addSeoPage(data);
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
      setIsSubmitting(false);
   //   closeDrawer();
    }
    finally{
      setLoading(false);
    }
  };

  const getHourRentalBasicRateData = async () => {
    try {
      const res = await SeoPageServices.getSeoPageById(id);
      if (res) {

       
        setValue("url",res.data.url);
        setValue("description", res.data.description);
        setValue("keywords", res.data.keywords);
        setValue("title",res.data.title);
        setValue("heading",res.data.heading);
      
        setValue("content", res.data.content);
        setValue("type_of_trip", res.data.type_of_trip);
        setSelectedTripType(res.data.type_of_trip);
        setSelectedtoCity(res.data.to_city_id);
        setSelectedfromCity(res.data.from_city_id);
        setSelectedfromCityName(res.data.from_city);
        setSelectedtoCityName(res.data.to_city);
        setContent(res.data.content);
       
        
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
    }
  };

  useEffect(() => {
    if (!isDrawerOpen) {
     
        setValue("url");
        setValue("description");
        setValue("keywords");
        setValue("title");
        setValue("heading");
        setValue("content");
        setValue("type_of_trip");
        setSelectedTripType("");
        setSelectedtoCity("");
        setSelectedfromCity("");
        setContent("");
        clearErrors(); 
  
      return;
    }
      
    if (id) {
      getHourRentalBasicRateData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, setValue, isDrawerOpen, clearErrors]);


  return {
    register,
    handleSubmit,
    onSubmit,
    handletoCityChange,
    handlefromCityChange,
    selectedfromCity,
    selectedtoCity,
    selectedfromCityName,
    selectedtoCityName,
    setSelectedfromCity,
    setSelectedtoCity,
    setSelectedfromCityName,
    setSelectedtoCityName,
    trigger,
    errors,
    isSubmitting,
    selectedVehicleCategory,
    setSelectedVehicleCategory,
    handleVehicleCategoryChange,
    selectedOptions,
    setSelectedOptions,
    setDataInput,
    dataInput,
    handleChangeInput,
    content, setContent,
    setSelectedTripType,selectedTripType,loading,setLoading
  };
};

export default useSeoPageSubmit;
